<div class="popupu_card pc_wo_bg" style="display: flex;" *ngIf="show">
    <div class="popup_inner">
        <a (click)="closeDialog('')" class="pc_close_btn"><i class="icon-close"></i></a>
        <div class="pwb_inner">
            <div class="dc_checkin_card">
                <div class="dcc_show_card" *ngIf="businessList.length >0">
                    <ng-container *ngFor="let obj of businessList; let k = index;">
                        <app-CustomerTemplate [srcfrm]="2" [edit_show]="true" [data]="obj" (CallParent)="closeDialog($event)"></app-CustomerTemplate>
                    </ng-container>
                </div>
            </div>
        </div>
    </div>
</div>